export default __webpack_public_path__ + "static/media/MoreMobile.dc73f8e4.svg";